import React, { forwardRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { cloneDeep, isEqual } from 'lodash';
import { useImperativeHandle } from 'react';
import { batch } from 'react-redux';
import {
  SAVE_ENTITLEMENT_BTN_LABEL,
  VIEW_SUMMARY,
  RESET_BTN,
  SAVE_ERROR_STUDY_REQUIRED,
  SAVE_ERROR_PRODUCT_DELIVERABLE,
  SEAT_MAX_REQUIRED,
  SAVE_ERROR_ENTITLEMENT_NAME,
  SAVE_LOCATIONS_ERROR_REQUIRED,
  UPDATE_SUCCESS_MESSAGE,
  SAVE_SUCCESS_MESSAGE,
  SAVE_ERROR_LOCAL_MARKETS_REQUIRED,
} from '../../constants';
import { StyledButton, ResetButton } from '../../styledComponents';
import {
  setAddNewEntitlement,
  setAddNewFlag,
  setEditEntitlement,
  setIsSummary,
  setSupportNav,
  setUnsavedChangeFlag,
  setSelectedEntitlementId,
} from '../../../../actions/contractAdminActions';
import { useDispatch, useSelector } from '../../../common/react-redux-hooks';
import {
  mapLocProperties,
  mapProperties,
} from '../../../../util/ContractAdminUtils';
import {
  saveEntitlement,
  updateEntitlement,
} from '../../../../actions/entitlementActions';
import {
  filteredProdData,
  filteredStudyRequest,
} from '../../../../util/EntitlementUtils';
import CustomMultiSelect from './CustomMultiSelect';
import RldConfirm from './RldConfirmModal';
import PortalModal from '../../../common/Modal/PortalModal';
const rldModalStyles = {
  left: '30%',
  top: '10%',
  width: '450',
  height: '130,',
};
const EntitlementSave = forwardRef(
  (
    {
      setIsSaved,
      setSaveError,
      setIsSuccess,
      locations,
      studyData,
      prodData,
      selectedPropCodes,
      markets,
      memriDtos,
      memriChanged,
      handleAllLoc,
      prodChanged,
      studyChanged,
      marketChanged,
      propCodeChanged,
      setResetForm,
      handleLoc,
      propchanged,
    },
    ref
  ) => {
    const {
      editEntitlement,
      selectedEntitlementId,
      selectedContractId,
      isTPPAccountSelected,
      selectedLocations,
      editEntName,
      propCodes,
    } = useSelector(state => ({
      editEntitlement: state.contractAdmin.editEntitlement,
      selectedEntitlementId: state.contractAdmin.selectedEntitlementId,
      selectedContractId: state.contractAdmin.selectedContractId,
      isTPPAccountSelected:
        state.contractAdmin.addAccount.accountType === 'TPP',
      selectedLocations: state.contractAdmin.selectedLocations,
      editEntName: state.contractAdmin.editEntName,
      propCodes: state.contractAdmin.propCodes,
    }));
    const dispatch = useDispatch();
    const [entLocations, setEntLocations] = useState([]);
    const [entitlementName, setEntitlementName] = useState('');
    const [isLoading, setLoading] = useState(false);
    const [editEntLoc, setEditEntLoc] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState([]);
    const [isAnyDataUpdated, setIsAnyDataUpdated] = useState(true);
    const [nameChanged, setNameChanged] = useState(true);
    const [locChanged, setLocChanged] = useState(true);
    const [isRldConfirmOpen, setIsRldConfirmOpen] = useState(false);
    useImperativeHandle(ref, () => ({
      entData: () => {
        return [!isAnyDataUpdated];
      },
    }));
    useEffect(() => {
      ref.current.isAnyDataUpdated = !isAnyDataUpdated;
    }, [isAnyDataUpdated]);
    useEffect(() => {
      setResetForm(false);
      const isAnyDataupdate =
        locChanged &&
        nameChanged &&
        prodChanged &&
        studyChanged &&
        marketChanged &&
        memriChanged &&
        propchanged &&
        propCodeChanged;
      setIsAnyDataUpdated(isAnyDataupdate);
    }, [
      locChanged,
      nameChanged,
      locations,
      studyData,
      prodData,
      markets,
      memriDtos,
      prodChanged,
      studyChanged,
      marketChanged,
      memriChanged,
      propCodeChanged,
      propchanged,
    ]);
    useEffect(() => {
      const editEntNameCopy = cloneDeep(editEntName);
      setEntitlementName(editEntNameCopy);
    }, [editEntName]);

    useEffect(() => {
      setNameChanged(isEqual(entitlementName, editEntName));
      if (entitlementName.length) {
        setIsAnyDataUpdated(false);
      }
    }, [entitlementName, editEntName]);

    const handleChange = e => {
      setEntitlementName(e.target.value);
    };
    useEffect(() => {
      if (locations) {
        setEntLocations([...locations]);
      }
    }, [locations]);

    useEffect(() => {
      if (entLocations && entLocations.length) {
        entLocations.map(location => {
          location.label = location.locationName;
          location.value = location.locationName;
          return location;
        });
        if (entLocations.length === 1) {
          setSelectedLocation(entLocations);
        } else if (!selectedLocation) {
          setSelectedLocation([]);
        }
      }
    }, [entLocations]);

    useEffect(() => {
      setLocChanged(
        isEqual(
          mapLocProperties(editEntLoc),
          mapLocProperties(selectedLocation)
        )
      );

      dispatch(setUnsavedChangeFlag(false));
    }, [selectedLocation, editEntLoc]);
    useEffect(() => {
      if (locations && locations.length && selectedLocations) {
        if (locations.length === 1) {
          setEditEntLoc(locations);
          setSelectedLocation(locations);
        } else {
          const filtered = [];
          locations.map((arr, i) => {
            selectedLocations.map((filter, i1) => {
              if (
                locations[i].locationId === selectedLocations[i1].locationId
              ) {
                filtered.push(locations[i]);
              }
              return filter;
            });
            return arr;
          });
          setEditEntLoc(filtered);
          setSelectedLocation(filtered);
        }
      }
    }, [selectedLocations, locations]);

    const getSelectedLocation = data => {
      const request = [];
      data.map(loc => {
        const location = {};
        location.locationId = loc.locationId;
        location.selected = true;
        request.push(location);
        return loc;
      });
      return request;
    };
    const resetForm = () => {
      setResetForm(true);
      setSaveError({
        status: false,
        message: '',
      });
      setIsSuccess('');
      if (editEntitlement) {
        setEntitlementName(editEntName);
        setSelectedLocation(editEntLoc);
      } else {
        setSelectedLocation(editEntLoc);
        setEntitlementName('');
      }
      setIsAnyDataUpdated(true);
    };

    const filteredProd = mapProperties(filteredProdData(prodData));
    const rldSelected = filteredProd.some(items => items.optionId === 8);
    const handleRldConfirm = () => {
      setIsRldConfirmOpen(true);
    };
    const handleSave = () => {
      const filteredStudyData = filteredStudyRequest(studyData);
      const filteredProd = mapProperties(filteredProdData(prodData));
      const isStudySel = studyData.some(
        e => e.isAnyChildSelected === true || e.selected === true
      );
      const isProdSel = prodData.some(
        e =>
          ((e.isAnyChildSelected === true || e.selected === true) &&
            !e.disable) ||
          (isTPPAccountSelected &&
            e.optionName === 'Third Party Provider' &&
            (e.isAnyChildSelected === true || e.selected === true))
      );
      const isMaxSeatsSel = filteredProd.find(
        obj => obj.seatsRequired && !obj.maxSeats
      );
      const propCodesId = [];
      if (selectedPropCodes) {
        selectedPropCodes.map(e =>
          e.id.forEach(element => {
            propCodesId.push(element);
          })
        );
      }
      dispatch(setUnsavedChangeFlag(false));
      // save only filtered ones
      setSaveError({ status: false, message: '' });
      setIsSuccess('');
      if (!isStudySel) {
        setSaveError({ status: true, message: SAVE_ERROR_STUDY_REQUIRED });
      } else if (isStudySel) {
        const isLocalMarketStudy = filteredStudyData.find(
          data => data.optionName === 'Local Flex'
        );

        const isLocMarketSelected =
          markets.length && markets.find(obj => obj.studySource === 1)
            ? markets.find(obj => obj.studySource === 1).ids.length
            : 0;
        if (isLocalMarketStudy && !isLocMarketSelected) {
          setSaveError({
            status: true,
            message: SAVE_ERROR_LOCAL_MARKETS_REQUIRED,
          });
        } else if (!isProdSel) {
          setSaveError({
            status: true,
            message: SAVE_ERROR_PRODUCT_DELIVERABLE,
          });
        } else if (isMaxSeatsSel) {
          setSaveError({ status: true, message: SEAT_MAX_REQUIRED });
        } else if (!entitlementName.trim()) {
          setSaveError({ status: true, message: SAVE_ERROR_ENTITLEMENT_NAME });
        } else if (!selectedLocation.length) {
          setSaveError({
            status: true,
            message: SAVE_LOCATIONS_ERROR_REQUIRED,
          });
        } else {
          const request = {
            contractId: selectedContractId,
            entitlementName: entitlementName.trim(),
            entitlementId: editEntitlement ? selectedEntitlementId : null,
            entitlementFeatureSetDtos: filteredProd,
            entitlementDtos: filteredStudyData,
            entitlementLocationDtos: getSelectedLocation(selectedLocation),
            dmaMarkets: markets,
            memriUsersSelectedDtos: memriDtos,
            propCodeIds: propCodesId,
          };
          setIsSaved(false);
          setLoading(true);
          const actionData = editEntitlement
            ? dispatch(
                updateEntitlement(request, isTPPAccountSelected, propCodes)
              )
            : saveEntitlement(request);
          actionData.then(response => {
            setLoading(false);

            if (response.error) {
              setSaveError({ status: true, message: response.error });
            }
            if (response.data && response.data.status === 200) {
              setIsAnyDataUpdated(true);
              const message = editEntitlement
                ? UPDATE_SUCCESS_MESSAGE
                : SAVE_SUCCESS_MESSAGE;
              setIsSuccess(message);
              if (!editEntitlement) {
                dispatch(setSupportNav('Contract', 'Entitlement Creation'));
                dispatch(setAddNewFlag(false));
                dispatch(setEditEntitlement(true));
                dispatch(setIsSummary(false));
                dispatch(
                  setSelectedEntitlementId(response.data.data.entitlementId)
                );
              }
              setIsSaved(true);
            }
            if ((response.data && response.data.error) || response.error) {
              setSaveError({
                status: true,
                message:
                  (response.data && response.data.message) ||
                  response.message ||
                  response.error,
              });
            }
          });
        }
      }
    };
    const sendLocList = () => {
      handleLoc(selectedLocation);
    };
    sendLocList();

    const sendAllLoc = () => {
      handleAllLoc(entLocations);
    };
    sendAllLoc();

    const setSummaryFlag = () => {
      if (isAnyDataUpdated) {
        batch(() => {
          dispatch(setSupportNav('Contract', 'Summary'));
          dispatch(setAddNewFlag(false));
          dispatch(setAddNewEntitlement(false));
          dispatch(setIsSummary(true));
          dispatch(setEditEntitlement(false));
        });
      } else {
        dispatch(setUnsavedChangeFlag(true));
      }
    };
    const closeModal = () => {
      setIsRldConfirmOpen(false);
    };
    return (
      <div className="ent-save">
        <div className="ent-save-input">
          <input
            type="text"
            name="entitlementName"
            id="entitlementName"
            value={entitlementName}
            maxLength="255"
            placeholder="Entitlement Name"
            onChange={handleChange}
          />
        </div>
        <div className="multi-select">
          <CustomMultiSelect
            options={entLocations}
            value={selectedLocation}
            onChange={setSelectedLocation}
          />
        </div>
        <div className="ent-save-btn">
          <ResetButton onClick={resetForm} disabled={isAnyDataUpdated}>
            {RESET_BTN}
          </ResetButton>
          <StyledButton
            onClick={rldSelected ? handleRldConfirm : handleSave}
            disabled={(editEntitlement && isAnyDataUpdated) || isLoading}
          >
            {SAVE_ENTITLEMENT_BTN_LABEL}
          </StyledButton>
        </div>
        <div className="ent-view-summary-btn">
          <StyledButton onClick={() => setSummaryFlag(true)}>
            {VIEW_SUMMARY}
          </StyledButton>
        </div>
        {isRldConfirmOpen && (
          <PortalModal
            title={'RLD Confirmation'}
            isShowing={isRldConfirmOpen}
            dialogStyles={rldModalStyles}
            onCloseClicked={closeModal}
          >
            <RldConfirm
              onContinueClicked={handleSave}
              setIsRldConfirmOpen={setIsRldConfirmOpen}
              isRldConfirmOpen={isRldConfirmOpen}
            />
          </PortalModal>
        )}
      </div>
    );
  }
);

EntitlementSave.propTypes = {
  setIsSaved: PropTypes.func,
  setSaveError: PropTypes.func,
  handleLoc: PropTypes.func,
  handleAllLoc: PropTypes.func,
  setIsSuccess: PropTypes.func,
  locations: PropTypes.arrayOf(PropTypes.object),
  studyData: PropTypes.arrayOf(PropTypes.object),
  prodData: PropTypes.arrayOf(PropTypes.object),
  selectedPropCodes: PropTypes.arrayOf(PropTypes.object),
  markets: PropTypes.arrayOf(PropTypes.object),
  memriDtos: PropTypes.arrayOf(PropTypes.object),
  prodChanged: PropTypes.bool,
  studyChanged: PropTypes.bool,
  marketChanged: PropTypes.bool,
  memriChanged: PropTypes.bool,
  propCodeChanged: PropTypes.bool,
  setResetForm: PropTypes.func,
  propchanged: PropTypes.bool,
};

export default EntitlementSave;
